import React, { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { StringMessage } from 'first-intl';
import { _ } from '@hugendubel/utils';
import { Select, SelectOption } from '@hugendubel/react-basic';
import { SearchService, SortField } from '../../../services/search-service';
import { useNavigate } from 'react-router-dom';

type SortOption = { sort: SortField; ascending: boolean; label: StringMessage };

export const _SearchSort = {
    getOptions: (): SortOption[] => [
        {
            sort: SortField.BONUS_COST,
            ascending: false,
            label: { id: process.env.IS_HUDU ? 'page.Home.sort.bonus.desc.hudu' : 'page.Home.sort.bonus.desc.eBook' },
        },
        {
            sort: SortField.BONUS_COST,
            ascending: true,
            label: { id: process.env.IS_HUDU ? 'page.Home.sort.bonus.asc.hudu' : 'page.Home.sort.bonus.asc.eBook' },
        },
        { sort: SortField.PUBLICATION_DATE, ascending: false, label: { id: 'page.Home.sort.publicationDate.desc' } },
        { sort: SortField.PUBLICATION_DATE, ascending: true, label: { id: 'page.Home.sort.publicationDate.asc' } },
        { sort: SortField.TITLE, ascending: false, label: { id: 'page.Home.sort.title.desc' } },
        { sort: SortField.TITLE, ascending: true, label: { id: 'page.Home.sort.title.asc' } },
        { sort: SortField.AUTHORS, ascending: false, label: { id: 'page.Home.sort.authors.desc' } },
        { sort: SortField.AUTHORS, ascending: true, label: { id: 'page.Home.sort.authors.asc' } },
    ],
};

export const SortOptions: SortOption[] = _SearchSort.getOptions();

const sortSelectOptions: ReadonlyArray<SelectOption<SortOption>> = SortOptions.map((sortOption: SortOption) => ({
    value: sortOption,
    label: sortOption.label,
}));

const getSortOptionFromSearch = (search: string): SortOption => {
    const sort = SearchService.getSortFromSearch(search);
    const ascending = SearchService.getAscendingFromSearch(search);
    return (
        _.first(SortOptions, (option: SortOption) => option.sort === sort && option.ascending === ascending) ||
        SortOptions[0]
    );
};

export const SearchSort: React.FC = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const onChange = useCallback(
        ({ sort, ascending }: SortOption): void => {
            // eslint-disable-next-line no-console
            console.log('test ' + process.env.BASENAME);
            navigate(SearchService.calculateUrl({ sort, ascending, page: 1 }));
        },
        [navigate]
    );
    const sort: SortOption = useMemo(() => getSortOptionFromSearch(search), [search]);

    return <Select className="label-hidden" value={sort} onChange={onChange} options={sortSelectOptions} />;
};
